/**
 * * Booking search transport page [find transport page]
 */
import { appQueryParameters } from '@clubmed/utils';
import { get } from 'lodash';
import Head from 'next/head';
import { useRouter } from 'next/router';
import React, { Fragment } from 'react';
import { TRACK_EVENT_NAMES } from 'Tracking/constants';
import { useTrackEvent } from 'Tracking/tracking-api/useTrackEvent';
import { renderInfoBanner } from 'Components/widgets/info-banner/infoBanner.utils';
import type { InfoBannerData } from 'Components/widgets/info-banner/infoBanner.query';
import 'Components/widgets/info-banner/infoBanner.query';
import { useBookingNavbar } from 'Components/widgets/booking-navbar/useBookingNavbar';
import { TransportsSection } from './TransportsSection';
import { TransfersView } from './TransfersView';
const TRANSPORTS_LAYER_NAME = 'AdditionalTransportsLayer';
type TransportsViewProps = {
  i18n: I18N;
  proposals: Array<Proposal>;
  selectedProposal: Proposal;
  resort: Product;
  infoBannerData: InfoBannerData;
  closeLayer: (arg0: boolean | null | undefined, arg1: string | null | undefined) => void;
  openLayer: (arg0: string) => void;
};
export const TransportsView = ({
  i18n,
  proposals,
  selectedProposal,
  resort,
  infoBannerData,
  closeLayer,
  openLayer,
}: TransportsViewProps) => {
  useBookingNavbar({
    noEdit: false,
  });
  const router = useRouter();
  const { query: queryParams } = router;
  const { trackClickEvent } = useTrackEvent();

  const onMoreTransportsClick = (): void => {
    trackClickEvent(TRACK_EVENT_NAMES.CLICK_TRANSPORT, {
      detail_click: 'see_more_transport',
    });
    openLayer(TRANSPORTS_LAYER_NAME);
  };

  return (
    <Fragment>
      {renderInfoBanner({
        infoBannerData,
        departureDate: selectedProposal.departureDate,
        arrivalDate: selectedProposal.arrivalDate,
        currentStep: selectedProposal.transports ? 'transport' : 'transfert',
      })}
      <Head>
        <title key="title">
          {get(
            i18n,
            selectedProposal.transports
              ? 'booking.transport.seo.title'
              : 'booking.transport.transfer.seo.title',
          )}
        </title>
      </Head>
      {selectedProposal.transports ? (
        <TransportsSection
          i18n={i18n}
          proposals={proposals}
          selectedProposal={selectedProposal}
          onMoreTransportsClick={onMoreTransportsClick}
          shouldShowLayer={queryParams[appQueryParameters.openLayer] === TRANSPORTS_LAYER_NAME}
          closeLayer={closeLayer}
          resort={resort}
        />
      ) : (
        <TransfersView proposals={proposals} selectedProposal={selectedProposal} resort={resort} />
      )}
    </Fragment>
  );
};
